import { render, staticRenderFns } from "./Stripe.vue?vue&type=template&id=3ed8c31a&scoped=true&"
import script from "./Stripe.vue?vue&type=script&lang=js&"
export * from "./Stripe.vue?vue&type=script&lang=js&"
import style0 from "./Stripe.vue?vue&type=style&index=0&id=3ed8c31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8c31a",
  null
  
)

component.options.__file = "Stripe.vue"
export default component.exports